module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showConfig,
      "title": (_vm.consulta ? 'CONFIGURAÇÕES DA CONSULTA Nº ' + _vm.consulta.id_con + ' - ' + _vm.consulta.funcionario.nome : ''),
      "width": "90%"
    }
  }, [(_vm.consulta) ? _c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('Config', {
    attrs: {
      "show": _vm.showConfig,
      "consulta": _vm.consulta
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.config.loading.table,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c139474c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/consulta/index.vue
// module id = 1548
// module chunks = 45